import { useEventListener } from 'usehooks-ts';

type UseDayPickerCalendarFocusController = {
  isCalendarFocused: boolean;
  setIsCalendarFocused: (focused: boolean) => void;
  closeCalendar: () => void;
  onTapEnter: () => void;
};

export const useDayPickerCalendarFocusController = (
  params: UseDayPickerCalendarFocusController
) => {
  const { isCalendarFocused, setIsCalendarFocused, closeCalendar, onTapEnter } =
    params;
  // Only when the calendar is mounted
  useEventListener('keydown', (event) => {
    if (event?.key?.toLowerCase() === 'arrowdown') {
      event.preventDefault();
      setIsCalendarFocused(true);
    }
    if (event?.key?.toLowerCase() === 'escape') {
      event.preventDefault();
      closeCalendar();
    }
    if (!isCalendarFocused && event?.key?.toLowerCase() === 'enter') {
      onTapEnter();
      event.preventDefault();
      closeCalendar();
    }
  });
};
